package com.devi3east.bashbuddy.auth.ui.components

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.LinkAnnotation
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextLinkStyles
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration

@Composable
fun TermsOfServiceText(
    onNavigateToTerms: () -> Unit
) {
    val annotatedText = buildAnnotatedString {
        append("I have read and agree to the ")

        pushLink(
            LinkAnnotation.Clickable(
                tag = "TERMS",
                styles = TextLinkStyles(
                    style = SpanStyle(
                        color = MaterialTheme.colorScheme.primary,
                        textDecoration = TextDecoration.Underline,
                        fontWeight = FontWeight.SemiBold
                    )
                ),
                linkInteractionListener = {
                    // Trigger navigation callback
                    onNavigateToTerms()
                }
            )
        )
        append("Terms of Service")
        pop()

        append(".")
    }

    Text(
        text = annotatedText,
        style = MaterialTheme.typography.bodyMedium.copy(
            color = MaterialTheme.colorScheme.onSurface
        )
    )
}